<!-- <app-header-one [sticky]="true" *ngIf="url != '/pages/comingsoon'"></app-header-one> -->
<!-- <app-header-three [sticky]="true"></app-header-three>
<router-outlet></router-outlet>
<app-footer-one *ngIf="url != '/pages/comingsoon'"></app-footer-one> -->
<div class="main-container">
    <app-mfg-header></app-mfg-header>
    <router-outlet></router-outlet>
    <div class="footer" *ngIf="user">
        <app-mfg-footer></app-mfg-footer>
    </div>
</div>